export const revenueFeatures = [
  {
    image: require("../../../image/CoinbaseNew/rev-img-one.webp"),
    title: "Multiple Cryptocurrencies Support",
    description:
      "Our script allows users to trade a wide range of cryptocurrencies, attracting diverse investors and driving higher trading volumes, resulting in increased revenue opportunities.",
  },
  {
    image: require("../../../image/CoinbaseNew/rev-img-two.webp"),
    title: "Quick KYC/AML Verification",
    description:
      "By facilitating swift and hassle-free Know Your Customer (KYC) and Anti-Money Laundering (AML) verifications, our script ensures faster onboarding of users, leading to accelerated revenue growth.",
  },
  {
    image: require("../../../image/CoinbaseNew/rev-img-three.webp"),
    title: "Real-Time Market Data",
    description:
      "Offering real-time cryptocurrency market data and charts, our script empowers users to make informed decisions, encouraging more frequent trading and thus, higher revenue generation.",
  },
  {
    image: require("../../../image/CoinbaseNew/rev-img-four.webp"),
    title: "Advanced Trading Tools",
    description:
      "Equipped with advanced trading tools like stop-loss and take-profit orders, our script attracts professional traders, leading to a rise in trading activities and revenue potential.",
  },
  {
    image: require("../../../image/CoinbaseNew/rev-img-five.webp"),
    title: "Margin Trading Option",
    description:
      "With the inclusion of margin trading, our script caters to high-volume traders, offering leveraged trading opportunities and, in turn, generating more revenue for your platform.",
  },
  {
    image: require("../../../image/CoinbaseNew/rev-img-six.webp"),
    title: "Referral & Affiliate Programs",
    description:
      "Implementing referral and affiliate programs in our script incentivizes users to invite others, expanding your customer base and increasing revenue through commission earnings.",
  },
  {
    image: require("../../../image/CoinbaseNew/rev-img-seven.webp"),
    title: "Enhanced Liquidity Options",
    description:
      "Our Coinbase clone script integrates liquidity features, ensuring smoother transactions, reduced slippage, and attracting liquidity providers, all of which contribute to higher revenue.",
  },
  {
    image: require("../../../image/CoinbaseNew/rev-img-eight.webp"),
    title: "Customizable Transaction Fees",
    description:
      "Offering the flexibility to customize transaction fees allows you to optimize revenue by adapting to market conditions and user preferences.",
  },
  {
    image: require("../../../image/CoinbaseNew/rev-img-nine.webp"),
    title: "Multi-Language Support",
    description:
      "Providing multilingual support expands your platform's global reach, attracting users from diverse linguistic backgrounds, and thereby increasing revenue potential.",
  },
  {
    image: require("../../../image/CoinbaseNew/rev-img-ten.webp"),
    title: "24/7 Customer Support",
    description:
      "Offering round-the-clock customer support builds trust among users, leading to increased user retention, higher trading activities, and ultimately, greater revenue.",
  },
];

export const featureSlides = [
  {
    img: "https://res.cloudinary.com/djcn5wxkj/image/upload/v1777354563/fe_img_one_wpar7i_1_y3aj4r.webp",
    title: "User Registration",
    description:
      "Allow users to sign up and create their accounts easily, providing essential information for account verification.",
  },
  {
    img: "https://res.cloudinary.com/djcn5wxkj/image/upload/v1777354618/fe_img_two_cu1m4h_1_kfepma.webp",
    title: "Wallet Integration",
    description:
      "Enable users to generate and manage their cryptocurrency wallets securely within the platform.",
  },
  {
    img: "https://res.cloudinary.com/djcn5wxkj/image/upload/v1777354756/fe_img_three_vvyxpe_1_um6eq9.webp",
    title: "Buy/Sell Cryptocurrencies",
    description:
      "Provide a seamless process for users to buy and sell various cryptocurrencies using multiple payment methods",
  },
  {
    img: "https://res.cloudinary.com/djcn5wxkj/image/upload/v1777354823/fe_img_four_mustbm_1_ba4uwt.webp",
    title: "Real-Time Market Data",
    description:
      "Integrate live cryptocurrency price data to ensure users have access to up-to-date market information.",
  },
  {
    img: "https://res.cloudinary.com/djcn5wxkj/image/upload/v1777357009/fe_img_five_oehosv_1_l2tc8r.webp",
    title: "Transaction History",
    description:
      "Offer users a comprehensive overview of their past transactions, enabling them to track their trading activities easily.",
  },
  {
    img: "https://res.cloudinary.com/djcn5wxkj/image/upload/v1777357141/fe_img_six_gruzi2_1_igi10z.webp",
    title: "Two-Factor Authentication (2FA)",
    description:
      "Implement an additional layer of security with 2FA to protect users' accounts from unauthorized access.",
  },
  {
    img: "https://res.cloudinary.com/djcn5wxkj/image/upload/v1777357084/fe_img_seven_nogdyf_1_kyeoro.webp",
    title: "Admin Panel",
    description:
      "Create a robust admin dashboard to manage user accounts, transactions, security settings, and other essential aspects of the exchange.",
  },
  {
    img: "https://res.cloudinary.com/djcn5wxkj/image/upload/v1777354971/fe_img_eight_pfwvqj_1_hrzaar.webp",
    title: "Security Measures",
    description:
      "Implement top-notch security protocols to safeguard user funds and maintain the integrity of the platform.",
  },
];
